import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {EventListComponent} from './pages/event-list/event-list.component';
import {HeaderComponent} from './components/header/header.component';
import {FooterComponent} from './components/footer/footer.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi,} from '@angular/common/http';
import {DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {SummaryComponent} from './pages/summary/summary.component';
import {CalendarComponent} from './pages/calendar/calendar.component';
import {PreLandingComponent} from './pages/landing/pre-landing/pre-landing.component';
import {EditBookingComponent} from './pages/edit-booking/edit-booking.component';
import {DeleteCompletedComponent} from './pages/delete-completed/delete-completed.component';
import {CompleteBookingComponent} from './pages/complete-booking/complete-booking.component';
import {AngularMaterialModule, MyDateAdapter,} from './angular-material.module';
import {EventDetailsComponent} from './components/dialog/event-details/event-details.component';
import {SelectUsersComponent} from './pages/select-users/select-users.component';
import {HomeLandingComponent} from './pages/landing/home-landing/home-landing.component';
import {LoginLandingComponent} from './pages/landing/login-landing/login-landing.component';
import {NotAllowedComponent} from './pages/landing/not-allowed/not-allowed.component';
import {HandleReservationsComponent} from './pages/handle-reservations/handle-reservations.component';
import {EventReservationsComponent} from './components/dialog/event-reservations/event-reservations.component';
import {HttpConfigInterceptor} from './interceptor/httpconfig.interceptor';
import {DateValidatorDirective} from './directives/date-validator.directive';
import {UserValidatorDirective} from './directives/user-validator.directive';
import {GenericConfirmationComponent} from './components/dialog/generic-confirmation/generic-confirmation.component';
import { TranslateModule  } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {LocaleService} from './service/locale.service';
import {SpinnerModule} from './components/spinner/spinner.module';
import {LANGUAGES} from './constants/lang';
import {HeaderLandingComponent} from './components/header-landing/header-landing.component';
import {LayoutComponent} from './pages/layout/layout.component';
import {MessagesComponent} from './pages/landing/messages/messages.component';
import {ReservationComponent} from './pages/reservation/reservation.component';
import {DateDirective} from './pages/landing/login-landing/date.directive';
import {HomeCategoryComponent} from './pages/landing/home-category/home-category.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    EventDetailsComponent,
    EventReservationsComponent,
    EventListComponent,
    SummaryComponent,
    CalendarComponent,
    PreLandingComponent,
    CompleteBookingComponent,
    EditBookingComponent,
    DeleteCompletedComponent,
    SelectUsersComponent,
    HomeLandingComponent,
    HomeCategoryComponent,
    LoginLandingComponent,
    NotAllowedComponent,
    HandleReservationsComponent,
    DateValidatorDirective,
    UserValidatorDirective,
    GenericConfirmationComponent,
    HeaderLandingComponent,
    LayoutComponent,
    MessagesComponent,
    ReservationComponent,
    DateDirective,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json'
      }),
    }),
    MatListModule,
    MatMenuModule,
    SpinnerModule,
  ],
  providers: [
    LocaleService,
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    { provide: DateAdapter, useClass: MyDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: LANGUAGES.it },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// export function createTranslateLoader(http: HttpClient) {
//   const loader = new TranslateHttpLoader(http, './assets/i18n/', '.json');
//   return loader;
// }

//export function createTranslateLoader(http: HttpClient) {
 // return new TranslateHttpLoader(http);
//}
